<template>
  <b-form-file
      accept=".xls, .xlsx"
      v-model="file"
      :browse-text="$t('btn.basic.browse')"
      :placeholder =" placeholder == null ? 'Choose a file or drop it here...' : placeholder" 
    ></b-form-file>
</template>

<script>

import axios from "axios";
import {mapState} from "vuex";

export default {
  data() {
    return {
      file: null
    };
  },
  props: ['placeholder'],
  watch: {
    file() {
      let size = this.file.size / 1024 / 1024;
      if (size > 10) {
        this.$notify.warning({
          title: "警告",
          message: `文件大小不得超过10M`
        });
        this.file = null;
      }
      if(this.file !== null)
        this.$emit("getFile",this.file)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>